// Y-axis display range for an open-ended chart, ported from the answer-variants block the family
// borrowed it from (getDisplayRange). The exporters ask for it so a static image keeps the axis the
// researcher is looking at; the rendered chart answers first, and this maths is the fallback for a
// chart that has not drawn yet.

import { getErrData } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/errData'

const NON_RANGE_CHART_MODES = ['map', 'none']

// respondent counts are reported per answer variant, so a non-case report reads its own percents
const percentsOf = (value, byCases) => (byCases ? value.percents : (value.respPercents ?? value.percents)) || 0

export const calcDisplayRange = ({
  chartMode,
  zoomLevel,
  globalChartMode,
  format = {},
  answer = {},
  answerVariants = [],
  rType = 'cases',
  ignoreAmount: ignoreAmountFlag,
  ignorePercents: ignorePercentsFlag,
  confidenceLevels = []
} = {}) => {
  if (NON_RANGE_CHART_MODES.includes(chartMode) || NON_RANGE_CHART_MODES.includes(globalChartMode)) return null

  if (!['min', 'max'].includes(zoomLevel)) return zoomLevel ?? null

  const percentsMode = String(chartMode ?? '').endsWith('percents')
  const mode = percentsMode ? 'percents' : 'amount'
  const percentsOnly = true === format?.percentsOnly

  const ignoreAmount = percentsOnly || ignoreAmountFlag || false
  const ignorePercents = true === format?.amountOnly || ignorePercentsFlag || false
  const byCases = null == rType || 'cases' === rType

  const max = Math.ceil(
    (answerVariants || []).reduce((acc, av) => {
      if (!av) return acc

      const value = answer[`a${av.position}`] || { amount: 0, percents: 0 }
      const { maxErrValue } = getErrData(value, mode, {
        ignoreAmount,
        ignorePercents,
        rType,
        answerType: 'amount',
        confidenceLevels
      })

      const plotted = percentsOnly || percentsMode ? percentsOf(value, byCases) : value.amount

      return Math.max(acc, parseFloat(plotted || 0) + (maxErrValue || 0))
    }, 0)
  )

  if ('max' === zoomLevel) {
    return [0, Math.max(max, (percentsMode && 100) || (byCases && answer.total) || answer.respTotal || 0)]
  }

  return [0, max]
}
